<template>
    <div>
        <compWrapper title="基本信息" theme="primary">
            <div class="margin-top-20 margin-left-20" style="display:flex">
                <div style="width:50%">计费项目：{{dataone.name}}</div>
                <div style="width:50%">使用范围：{{dataone.billingChannels?dataone.billingChannels.map(item => item ===
                    'RECEIVABLE' ? '应收': item === 'PAYABLE' ? '应付' : '--').join('、'):'--'}}
                </div>
            </div>
        </compWrapper>
        <compWrapper title="规则列表" theme="info">
            <div class="margin-15">
                <Button type="primary" @click="submit">保存</Button>
                <Button class="margin-left-10" @click="deleteall">删除全部</Button>
                <Button class="margin-left-10" @click="additem">新增一行</Button>
            </div>
            <div class="margin-15">
                <div v-if="dataone.expenseCategoryType!=1">
                    <p>说明：仓库作业费均为按单计费</p>
                    <p>同一规则分组中，条件互斥，且根据自上而下的优先级进行匹配，匹配到规则后，后续规则不再匹配公式非必填，当现有规则无法满足的情况下，可通过公式进行进一步约束，具体公式填写规则见”公式说明“</p>
                </div>
                <!-- <div v-else>
                    <p>说明：</p>
                    <p>仓储费原计费体积单位为立方英尺（包仓除外），自2023年1月12日开始切换为立方米，请检查并更新报价，2023年1月12日之前生成的费用如需按立方米结算，可手动重新结算。</p>
                </div> -->
                <vTable class="margin-top-10" :columns="logColumn" :data="dataList" size="small" ref="table"></vTable>
            </div>
            <div class="margin-15">
                公式说明：
            </div>
        </compWrapper>
        <!-- 操作历史 -->
        <compWrapper title="操作历史" theme="gray">
            <compLog :data="logList"></compLog>
        </compWrapper>
        <!-- 全局弹框 -->
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="modalProps.show=false"
        >
            <component ref="cusref" :is="modalProps.component" v-bind="modalProps" v-on="modalProps.on"></component>
        </compModal>
    </div>
</template>

<script>
    import {
        HttpSaveBillRuleOne,
        HttpDeleteBillRuleOne,
        HttpQueryBillRuleOne,
        HttpTransactionList
    } from '@/service/newbigaccount';
    import {
        HttpGetBillingUnit,
        HttpGetBillingUnitCondition,
    } from '@/service/bespeak';
    

    export default {
        props: ['dataone'],
        data() {
            return {

                dataList: [],
                logList: [],
                flagdatalist: false,
                modalProps: {
                    show: false,
                    title: "",
                    component: null
                },
                otherOptionList: [],
                storeList:[],
                wareWorkList:[],
                valueAdList:[],
                billConditionEnum:[],
            }
        },
        created(){
            // 仓储的计费单位
            HttpGetBillingUnit({
                expenseCategoryType:'STORAGE'
            }).then(res=>{
                Object.keys(res.data).forEach((key)=>{
                    let jsonone = {
                        label:key,
                        value:res.data[key]
                    }
                    this.storeList.push(jsonone)
                })
            })
            // 仓库作业计费单位
            HttpGetBillingUnit({
                expenseCategoryType:'OPERATION'
            }).then(res=>{
                Object.keys(res.data).forEach((key)=>{
                    let jsonone = {
                        label:key,
                        value:res.data[key]
                    }
                    this.wareWorkList.push(jsonone)
                })
            })
            // 增值计费单位
            HttpGetBillingUnit({
                expenseCategoryType:'VALUE_ADDED'
            }).then(res=>{
                Object.keys(res.data).forEach((key)=>{
                    let jsonone = {
                        label:key,
                        value:res.data[key]
                    }
                    this.valueAdList.push(jsonone)
                })
            })
            // 一次性查询附加条件字典
            HttpGetBillingUnitCondition().then(res=>{
                this.billConditionEnum = res.data;
            })
        },
        watch: {
            dataone: {
                deep: true,
                immediate: true,
                handler(val) {
                    this.dataList = [];
                    this.update();
                    this.getOtherOptions();
                }
            }
        },
        computed: {
            billUnitEnum() {
                if (this.dataone.expenseCategoryType == 1) {
                    return this.storeList
                } else if (this.dataone.expenseCategoryType == 0) {
                    return this.wareWorkList
                } else if (this.dataone.expenseCategoryType == 3) {
                    return this.valueAdList
                }
            },
            logColumn() {
                let _this = this;
                return [
                    {
                        title: this.$t('global.common.operation', {defaultValue: '操作'}),
                        width: 70,
                        render(h, {row, index}) {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: "error",
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            _this.comremove(row, index)
                                        }
                                    }
                                }, _this.$t('global.common.delete', {defaultValue: '删除'}))
                            ])
                        }
                    },
                    {
                        type: "index",
                        title: "No.",
                        width: 60,
                        align: "center",
                    },
                    {
                        key: "code",
                        title: "ID",
                        align: "center",
                    },
                    {
                        renderHeader: (h, params) => { 
                            return h('div', [
                                h('strong', '名称')
                            ])
                        },
                        key: 'description',
                        render(h, {row, index}) {
                            return h('vInput', {
                                props: {
                                    size: 'small',
                                    value: row.description
                                },
                                on: {
                                    'input': (event) => {
                                        row.description = event
                                        _this.dataList[index] = row
                                    }
                                },
                            })
                        }
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('Icon', {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14"
                                    },
                                }),
                                h('strong', '规则分组')
                            ])
                        },
                        key: 'groupName',
                        render(h, {row, index}) {
                            return h('vInput', {
                                props: {
                                    size: 'small',
                                    value: row.groupName
                                },
                                on: {
                                    'input': (event) => {
                                        row.groupName = event
                                        _this.dataList[index] = row
                                    }
                                },
                            })
                        }
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('Icon', {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14"
                                    },
                                }),
                                h('strong', '计费条件')
                            ])
                        },
                        render(h, {row, index}) {
                            return h('vSelect', {
                                    attrs: {
                                        value: _this.dataList[index].billingUnit,
                                    },
                                    props: {transfer: true},
                                    on: {
                                        'on-change': (value) => {
                                            _this.dataList[index].billingUnit = value;
                                            _this.dataList[index].billingCondition = '';
                                            if (_this.dataone.expenseCategoryType == 0) {
                                                if (value == 103 || value == 200 || value == 11111|| value == 22222) {
                                                    _this.dataList[index].choseItemSpan = 1
                                                } else {
                                                    _this.dataList[index].choseItemSpan = 0
                                                }
                                            }else{
                                                if ( value == 11111|| value == 22222) {
                                                    _this.dataList[index].choseItemSpan = 1
                                                } else {
                                                    _this.dataList[index].choseItemSpan = 0
                                                }
                                            }
                                        }
                                    },
                                },
                                _this.billUnitEnum.map((json) => {
                                    return h('vOption', {
                                        props: json
                                    });
                                })
                            )
                        }
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('Icon', {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14"
                                    },
                                }),
                                h('strong', '附加条件')
                            ])
                        },
                        render(h, {row, index}) {
                            if (_this.dataList[index].choseItemSpan == 1) {
                                return<div> </div>
                            } else {
                                if (_this.dataone.expenseCategoryType == 0 || _this.dataone.expenseCategoryType == 1) {
                                    return h('vSelect', {
                                            attrs: {
                                                value: _this.dataList[index].billingCondition,
                                            },
                                            props: {transfer: true, filterable: true, clearable: true},
                                            on: {
                                                'on-change': (value) => {
                                                    _this.dataList[index].billingCondition = value;
                                                    let billingUnit = _this.dataList[index].billingUnit;
                                                    if (_this.billConditionEnum.hasOwnProperty(billingUnit)) {
                                                        _this.dataList[index].description = _this.billConditionEnum[billingUnit].filter(item => item.code == value)[0].name || "";
                                                    }
                                                }
                                            },
                                        },
                                        _this.billConditionEnum[_this.dataList[index].billingUnit] ? _this.billConditionEnum[_this.dataList[index].billingUnit].map((json) => {
                                            return h('vOption', {
                                                props:{
                                                    label:json.name,
                                                    value:json.code
                                                }
                                            });
                                        }) : "--"
                                    )
                                } else {
                                    return h('vSelect', {
                                            attrs: {
                                                value: _this.dataList[index].billingCondition,
                                            },
                                            props: {
                                                transfer: true,
                                                filterable: true,
                                                clearable: true,
                                                dropStyle: "width:auto"
                                            },
                                            on: {
                                                'on-change': (value) => {
                                                    _this.dataList[index].billingCondition = value;
                                                    _this.dataList[index].description = value
                                                }
                                            },
                                        },
                                        _this.otherOptionList.map((json) => {
                                            return h('vOption', {
                                                props: json
                                            });
                                        })
                                    )
                                }

                            }
                        }
                    },
                    {
                        width: _this.dataone.expenseCategoryType == 1 ? 'auto' : 0,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('Icon', {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14"
                                    },
                                }),
                                h('strong', '存储天数起')
                            ])
                        },
                        render(h, {row, index}) {
                            if (_this.dataList[index].choseItemSpan == 1) {
                                return<div> </div>
                            } 
                            else {
                                return h('vInput', {
                                    props: {
                                        size: 'small',
                                        value: row.attachValue
                                    },
                                    on: {
                                        'input': (event) => {
                                            row.attachValue = event
                                            _this.dataList[index] = row
                                        }
                                    },
                                })
                            }
                        }
                    },
                    {
                        width: _this.dataone.expenseCategoryType == 1 ? 'auto' : 0,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('Icon', {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14"
                                    },
                                }),
                                h('strong', '存储天数止')
                            ])
                        },
                        render(h, {row, index}) {
                            if (_this.dataList[index].choseItemSpan == 1) {
                                return<div> </div>
                            } 
                            else {
                                return h('vInput', {
                                    props: {
                                        size: 'small',
                                        value: row.attachValue1
                                    },
                                    on: {
                                        'input': (event) => {
                                            row.attachValue1 = event
                                            _this.dataList[index] = row
                                        }
                                    },
                                })
                            }
                        }
                    },
                    {
                        title: '公式',
                        key: 'formula',
                        render(h, {row, index}) {
                            return h('Input', {
                                props: {
                                    type:row.billingUnit==11111?'textarea':'',
                                    rows:1,
                                    size: 'small',
                                    value: row.formula
                                },
                                on: {
                                    'input': (event) => {
                                        row.formula = event
                                        _this.dataList[index] = row
                                    }
                                },
                            })
                        }
                    },
                ]
            }
        },
        methods: {
            getOtherOptions() {
                if (this.dataone.expenseCategoryType == 3) {
                    HttpTransactionList({
                        page: 1,
                        rows: 1000,
                        "search[EQ_status]": 'STATUS_ACTIVE'
                    }).then(res => {
                        this.otherOptionList = res.data.content.map(item => {
                            return {
                                value: item.transactionCode,
                                label: item.transactionCode
                            }
                        })
                    })
                }
            },
            dataSort(a, b) {
                if (a.groupName !== b.groupName) return a.groupName < b.groupName ? -1 : 1
                else if (a.code !== b.code) return a.code < b.code ? -1 : 1
            },
            update() {
                // console.log(this.dataone,'dataone')
                HttpQueryBillRuleOne({
                    id: this.dataone.id
                }).then(res => {
                    if (res.data.length > 0) {
                        this.flagdatalist = true;
                        this.dataList = res.data.filter(item => {
                            return item.type == 1
                        });
                        for (let i = 0; i < this.dataList.length; i++) {
                            if (this.dataone.expenseCategoryType == 0){
                                    if (this.dataList[i].billingUnit == 103 || this.dataList[i].billingUnit == 200 || this.dataList[i].billingUnit == 11111|| this.dataList[i].billingUnit == 22222) {
                                    this.dataList[i].choseItemSpan = 1
                                }
                            }else{
                                if (this.dataList[i].billingUnit == 11111|| this.dataList[i].billingUnit == 22222) {
                                    this.dataList[i].choseItemSpan = 1
                                }
                            }
                        }
                        this.dataList.sort(this.dataSort)
                    } else {
                        this.dataList = []
                    }
                }, err => {

                })
            },
            submit() {
                // console.log(this.dataList,'this.dataList')
                let dayflag = false, formulaflag = false, nameflag = false;
                this.dataList.map(item => {
                    item.parentId = this.dataone.id,
                        delete item._index;
                        delete item._rowKey;
                    if (Number(item.attachValue) > 9999 || Number(item.attachValue1) > 9999) {
                        dayflag = true
                    }
                    if (item.billingCondition == '403' && !item.formula) {
                        formulaflag = true;
                    }
                    if (item.billingUnit == 11111) {
                        item.billingCondition = 520
                        if(!item.description){
                            nameflag = true
                        }
                    }
                    if (item.billingUnit == 22222) {
                        item.billingCondition = 522
                    }
                    if (item.billingUnit == 103) {
                        item.billingCondition = 0
                    }
                })
                if (dayflag) {
                    this.$VMessage.error('存储天数填写不能超过9999');
                    return
                }
                if (formulaflag) {
                    this.$VMessage.error('third party重量下公式不能为空！');
                    return
                }
                if (nameflag) {
                    this.$VMessage.error('选中行是自定义逻辑时，名称不能为空！');
                    return
                }
                HttpSaveBillRuleOne({
                    data: this.dataList
                }).then(res => {
                    this.$VMessage.success('操作成功');
                    this.update();
                }, err => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
                })
            },
            comremove(row, index) {
                let _this = this;
                this.modalProps = {
                    show: true,
                    title: '删除',
                    alert: "error",
                    width: 460,
                    showDesc: true,
                    desc: '删除后不可恢复，请确认是否删除',
                    ajaxRequest: async () => {
                        if (row.id) {
                            _this.deletebillrule(row.id)
                        } else {
                            _this.dataList.splice(index, 1)
                        }
                    }
                }
            },
            deleteall() {
                let idsarr = []
                this.dataList.map(item => {
                    idsarr.push(item.id)
                })
                this.deletebillrule(idsarr)
            },
            deletebillrule(idsarr) {
                HttpDeleteBillRuleOne({
                    ids: idsarr
                }).then(res => {
                    this.$VMessage.success('删除成功');
                    // this.$VMessage.success(res.message);
                    this.update();
                }, err => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
                })
            },
            additem() {
                let jsonone = null
                if (this.dataone.expenseCategoryType == 1) {
                    jsonone = {
                        groupName: '',
                        billingUnit: 200,
                        billingCondition: 500,
                        choseItemSpan: 0,
                        formula: ''
                    }
                } else {
                    jsonone = {
                        groupName: '',
                        billingUnit: 100,
                        billingCondition: 0,
                        choseItemSpan: 0,
                        formula: ''
                    }
                }
                this.dataList.push(jsonone)
            }
        }
    }
</script>
